"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormActionType = void 0;
var FormActionType;
(function (FormActionType) {
    FormActionType["EMAIL_SUPERVISOR"] = "EMAIL_SUPERVISOR";
    FormActionType["EMAIL_PARTICIPANTS"] = "EMAIL_PARTICIPANTS";
    FormActionType["EMAIL_PERSON"] = "EMAIL_PERSON";
    FormActionType["SMS_SUPERVISOR"] = "SMS_SUPERVISOR";
    FormActionType["SMS_PARTICIPANTS"] = "SMS_PARTICIPANTS";
})(FormActionType = exports.FormActionType || (exports.FormActionType = {}));
//# sourceMappingURL=formActionType.js.map